class SearchModal extends HTMLElement {
    constructor() {
      super();
      
      this.modal = this.querySelector('.search-modal');
      this.detailsContainer = this.querySelector('details');
      this.summaryToggle = this.querySelector('summary');
      this.input = this.querySelector('.search__input')
      this.searchField = this.summaryToggle?.querySelector('.search-field__text')
      this.overlay = this.detailsContainer?.querySelector('.overlay')
      this.resetButton = this.querySelector('button[type="reset"]')

      if (!this.modal || !this.detailsContainer || !this.summaryToggle || !this.input || !this.overlay) return;
  
      document.addEventListener(
        'keyup',
        (event) => event.code && event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
    
        if (this.searchField) {
          this.summaryToggle.querySelector('.search-field__text').addEventListener('input', this.open.bind(this))
         
        } else {
          this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this))
        }
      this.resetButton?.addEventListener(
        'click',
        this.reset.bind(this)
      );
        
      this.summaryToggle.setAttribute('role', 'button');
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open(event);
    }
  
    onBodyClick(event) {
      if (event.target.classList.contains('overlay') || event.target.closest('.button-close')) this.close();
    }
  
    open() {
      if (this.modal.classList.contains('open')) return;
      this.opener = this.searchField || this.summaryToggle.querySelector('.search') || this.summaryToggle;
      document.body.appendChild(this.modal)
      document.body.appendChild(this.overlay)
      this.detailsContainer.setAttribute('open', true);
      this.summaryToggle.setAttribute('aria-expanded', 'true');
      this.overlay.classList.add('open');
      this.modal.classList.add('open');
      if (this.searchField) {
        this.input.setAttribute('value', this.searchField.value)
        this.input.value = this.searchField.value
        trapFocus(
          this.modal,
          this.input
        );
        this.input.setSelectionRange(this.searchField.value.length, this.searchField.value.length)
      }
      else {
        trapFocus(
          this.modal,
          this.input
        );
      }
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      this.detailsContainer.setAttribute('open', true);
      this.overlay.classList.add('open')
      document.body.addEventListener('click', this.onBodyClickEvent);
      document.body.classList.add('search-modal--open');
      document.body.classList.add('hidden')
      this.modal.classList.add('open')
    }
  
    close() {
      if (!this.modal?.classList.contains('open')) return;
      removeTrapFocus();
      this.detailsContainer.removeAttribute('open');
      this.summaryToggle.setAttribute('aria-expanded', 'false');
      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.body.classList.remove('search-modal--open');
      document.dispatchEvent(new CustomEvent('searchmodal:close'));
      document.body.classList.remove('hidden')
      this.modal.querySelector('.search__button-text')?.classList.add('hidden')
      this.modal.classList.remove('open')
      if (this.searchField) this.searchField.value = ''
      this.input.value = ''
      this.modal.querySelector('predictive-search')?.close(true);
      this.overlay.classList.remove('open');
      this.detailsContainer.append(this.modal, this.overlay);
      const menu = this.closest('.menu-drawer.open');
      if (menu) {
        document.body.classList.add('hidden');
        trapFocus(menu, this.opener);
      } else {
        this.opener?.focus({ preventScroll: true });
      }
    }
  
    reset(event) {
      event?.preventDefault();
      this.input.value = '';
      if (this.searchField) this.searchField.value = '';
    }
  }
  
  if (!customElements.get('search-modal')) customElements.define('search-modal', SearchModal);
